var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartActive = function SvgIconHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M10.96 2.57A3.7 3.7 0 0 0 8 4.057 3.7 3.7 0 0 0 5.04 2.57c-2.046 0-3.706 1.667-3.706 3.727 0 .793.126 1.527.346 2.207 1.053 3.333 4.3 5.326 5.907 5.873.227.08.6.08.827 0 1.606-.547 4.853-2.54 5.906-5.873.22-.68.347-1.414.347-2.207 0-2.06-1.66-3.727-3.707-3.727"
  })));
};
export default SvgIconHeartActive;